import { httpPostRequest } from "clients/phronesisClient"
import { isDevOrLocal } from "config/utils"

const FLAG_OPTIONS = {
	ON: "on",
	OFF: "off",
} as const

export const productionFeatureFlags = {
	transactional: "on",
	transactionalCommercial: "on",
	transactionalCommercialGrowthChart: "on",
	transactionalCommercialReachMetric: "on",
	transactionalCommercialFrequencyMetric: "on",
	transactionalCommercialDailyView: "on",
	transactionalCommercialWeeklyView: "on",
	transactionalCommercialMonthlyView: "on",
	transactionalGeographic: "on",
	transactionalBenchmark: "on",
	transactionalCrossSelling: "on",
	customerBehavior: "on",
	customerBehaviorCustomerHabits: "on",
	customerBehaviorCustomerHabitsRetention: "on",
	customerBehaviorCustomerHabitsBuyingHabits: "on",
	customerBehaviorCustomerHabitsBuyingHabitsTicketInfo: "on",
	customerBehaviorCustomerHabitsBuyingHabitsTicketInfoSpend: "on",
	customerBehaviorCustomerHabitsBuyingHabitsTicketInfoTicket: "on",
	customerBehaviorCustomerHabitsBuyingHabitsTicketInfoUnits: "on",
	customerBehaviorCustomerHabitsBuyingHabitsPaymentMethod: "on",
	customerBehaviorCustomerHabitsBuyingHabitsFrequency: "on",
	customerBehaviorCustomerHabitsTemporal: "on",
	customerBehaviorCustomerHabitsTemporalTransactions: "on",
	customerBehaviorCustomerHabitsTemporalTransactionsHour: "on",
	customerBehaviorCustomerHabitsTemporalTransactionsWeek: "on",
	customerBehaviorCustomerHabitsTemporalTransactionsMonth: "on",
	customerBehaviorCustomerHabitsTemporalPurchases: "on",
	customerBehaviorCustomerHabitsTemporalRecency: "on",
	customerBehaviorCustomerHabitsChannels: "on",
	userManagement: "on",
	userManagementUsers: "on",
	customerBehaviorCustomerClustering: "off",
	transactionalOperational: "off",
	customerBehaviorCustomerLoyalty: "off",
	customerBehaviorCustomerLoyaltyTable: "off",
	customerBehaviorCustomerPlatform: "off",
	customerBehaviorCustomerSensitivity: "off",
	customerBehaviorCustomerSwitching: "on",
	customerBehaviorCustomerProfiling: "on",
	customerBehaviorCustomerProfilingHousehold: "off",
	customerBehaviorCustomerProfilingHouseholdGender: "off",
	customerBehaviorCustomerProfilingHouseholdGenderAge: "off",
	customerBehaviorCustomerProfilingHouseholdChildren: "off",
	customerBehaviorCustomerProfilingNationality: "off",
	customerBehaviorCustomerProfilingIncomeQuintiles: "off",
	predictiveCenter: "off",
	predictiveCenterBrandingAndProductChurn: "off",
	predictiveCenterCoveragePrediction: "off",
	predictiveCenterPredictiveAssortments: "off",
	predictiveCenterProductRecommendation: "off",
	predictiveCenterPropensityStudies: "off",
	predictiveCenterPurchaseDrivers: "off",
	advertisementCenter: "off",
	advertisementCenterMediaCampaigns: "off",
	campaignTracker: "off",
	campaignTrackerMetricCards: "off",
	campaignTrackerDetails: "off",
	operationsStoreShortages: "off",
	performance: "off",
	performanceGrowthProfiling: "on",
	termsAndConditions: "off",
	sessionExpirationMessage: "off",
	facebookCampaigns: "off",
	transactionalBenchmarkTimeline: "off",
	transactionalBenchmarkMetricCards: "on",
	sellout: "on",
	selloutReport: "on",
	transactionalBenchmarkMetricSelect: "on",
	transactionalBenchmarkMetricSalesSelectFeatureFlagId: "on",
	transactionalBenchmarkMetricUnitsSelectFeatureFlagId: "on",
	transactionalBenchmarkMetricTransactionsSelectFeatureFlagId: "on",
	transactionalBenchmarkMetricClientsSelectFeatureFlagId: "on",
	transactionalBenchmarkMetricPenetrationSelectFeatureFlagId: "on",
	transactionalBenchmarkMetricAvgTicketSelectFeatureFlagId: "on",
	transactionalBenchmarkMetricAvgSpendSelectFeatureFlagId: "on",
	transactionalBenchmarkMetricAvgPriceSelectFeatureFlagId: "on",
	transactionalBenchmarkMetricPurchaseFrecuencySelectFeatureFlagId: "on",
	transactionalBenchmarkMetricItemsPerVisitSelectFeatureFlagId: "on",
	transactionalBenchmarkMetricStoresSellingSelectFeatureFlagId: "on",
	transactionalBenchmarkValueShareModelTab: "on",
	localUserLoginPageSwitch: "off",
	switchingBenchmarkTable: "on",
	labs: "off",
	labsCrossSelling: "off",
	newComponentTag: "on",
	medallia: "on",
	filtersValidations: "on",
	configuration: "on",
	changePw: "on",
	clearPeriod: "on",
	promotionBanner: "off",
	displayAdvertising: "off",
	valueShareModel: "off",
	benchmarkLocationTab: "on",
	sponsoredProducts: "off",
	penetrationSummary: "on",
	sankeySwitching: "on",
	customerTypeFilter: "off",
	customerSegmentation: "on",
	transactionalBenchmarkDoubleTimeline: "on",
	transactionalBenchmarkGrowthTimeline: "off",
	phronesisGlobalAlertMessage: "off",
} as const

export type FeatureFlagsKeys = keyof typeof productionFeatureFlags

export enum FetchedFeatureFlags {
	MigrationBannerEnabled = "front_migration_banner_enabled",
}

const FEATURE_FLAG_ENDPOINT = "/feature-flag"

export const isFetchedFeatureEnabled = async (
	featureFlag: FetchedFeatureFlags
): Promise<boolean> => {
	try {
		const response = await httpPostRequest(FEATURE_FLAG_ENDPOINT, {
			featureFlag,
		})
		return response.value
	} catch (error) {
		return false
	}
}

export const isFeatureEnabled = (id: FeatureFlagsKeys | string): boolean =>
	// @ts-ignore ignores key not being defined at object level, to re-enforce TS autocompletion
	isFeatureEnabledLocal() || productionFeatureFlags[id] === FLAG_OPTIONS.ON

export const isFeatureEnabledLocal = () => {
	const location = window.location.href
	return isDevOrLocal(location)
}
